
import MeaPage from "../../../components/MeaPage";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import trainingsAPI from "../../../services/trainings";

const RegistrationStatsPage = () => {

  //
  const toast = useRef();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const registrationId = params.registrationId;
  const accessToken = "";
  const registrationQuery = trainingsAPI.GetOne(
    schoolId,
    registrationId,
    accessToken
  );
  const registrationObj = registrationQuery?.data?.data;
  //
  return (
    <>
      <MeaPage title="Statistiques" showBackButton={false}>

      </MeaPage>
    </>
  );
};
export default RegistrationStatsPage;
